import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IPcr } from '../../pcr/store/pcr.types'
import { TimesConstants } from '../store/times.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { setTimes } from '../store/times.actions'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'

export function* getTimes(pcrDoc: IPcr) {
  const times = pcrDoc?.times
  if (times && Object.keys(times).length !== 0) {
    yield put(setTimes(times))
  }
}

export function* preloadPCR() {
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (!pcrID) return

  try {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    yield call(getTimes, pcrDoc)
  } catch (e) {
    yield put(throwPcrException(`preloadPCR() error in getTimes.saga.ts: ${e}`))
  }
}

export function* getTimesSaga() {
  yield takeLatest([TimesConstants.GET_TIMES], performWithMutexHOG, preloadPCR)
}
